import React from 'react';
import { motion } from 'framer-motion';
export function WhyAscensionSection() {
  return <section className="py-32 bg-ascension-black relative border-t border-white/5" data-id="element-172">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-174">
          <div className="w-16 h-1 bg-ascension-green mx-auto mb-12 rounded-full shadow-[0_0_15px_rgba(68,198,87,0.5)]" data-id="element-175" />

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-8" data-id="element-176">
            Most habit apps track behavior. <br data-id="element-177" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-ascension-green to-[#85e094]" data-id="element-178">
              Ascension enforces behavior.
            </span>
          </h2>

          <p className="text-lg md:text-xl text-ascension-gray leading-relaxed max-w-2xl mx-auto" data-id="element-179">
            By combining strict accountability, streak psychology, and
            device-level distraction blocking, Ascension helps you follow
            through on the habits that actually matter. No excuses.
          </p>
        </motion.div>
      </div>
    </section>;
}